import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import type { ICarbucksProtectFeature, ICarbucksProtectFeatureDto } from "./ICarbucksProtectFeature";
import { FeatureType } from "../WorkOrders/FeatureType";
import { FeatureStatus } from "@domain/General/Enums/FeatureStatus";
import type { IWorkOrderConfigurationDto } from "../WorkOrders/IWorkOrderConfiguration";

export class CarbucksProtectFeature implements ICarbucksProtectFeature
{

    isEnabledInAppSettings: boolean;
    hasCarbucksProtect: boolean;
    subscriberNumber?: string;
    title: string;
    subTitle: string;
    provider: string;
    termsAndConditionsLinkUrl?: string;
    phoneNumber: string;
    kilometerLimit: number;
    termInMonths: number;
    maximumLiability: number;
    dateActiveFrom?: string | Dayjs;
    dateActiveTo?: string | Dayjs;
    status: FeatureStatus;
    isUsed: boolean;
    workOrderConfigurations: IWorkOrderConfigurationDto[];
    
    get type() { return FeatureType.Protect }
    
    constructor( model: ICarbucksProtectFeatureDto )
    {
        this.isEnabledInAppSettings = model.isEnabledInAppSettings;
        this.hasCarbucksProtect = model.hasCarbucksProtect;
        this.subscriberNumber = model.subscriberNumber;
        this.title = model.title;
        this.subTitle = model.title;
        this.provider = model.provider;
        this.termsAndConditionsLinkUrl = model.termsAndConditionsLinkUrl;
        this.phoneNumber = model.phoneNumber;
        this.kilometerLimit = model.kilometerLimit;
        this.termInMonths = model.termInMonths;
        this.maximumLiability = model.maximumLiability;
        this.dateActiveFrom = model.dateActiveFrom == null ? undefined : dayjs( model.dateActiveFrom );
        this.dateActiveTo = model.dateActiveTo == null ? undefined : dayjs( model.dateActiveTo );
        this.status = model.status;
        this.isUsed = model.isUsed;
        this.workOrderConfigurations = model.workOrderConfigurations;
    }

    /**
     * True if the feature is enabled.  This is NOT the same as the feature being active
     */
    get isEnabled()
    {
        return this.hasCarbucksProtect && this.status > FeatureStatus.Draft;
    }

    /**
     * True if the feature is pending the consumer acknowledgement.  
     */
    get isPending()
    {
        return this.hasCarbucksProtect && this.status == FeatureStatus.Pending;
    }
    
    /**
     * True if the feature is active.  
     */
    get isActive()
    {
        return this.hasCarbucksProtect && this.status == FeatureStatus.Active;
    }

    /**
     * True if the feature is active.  
     */
    get isInactive()
    {
        return this.hasCarbucksProtect 
        && ( this.status == FeatureStatus.Expired || this.status == FeatureStatus.Cancelled || this.status == FeatureStatus.Voided );
    }

}